<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__progress">
        <BaseProgress :percent="progress" :count="progressCount" />
      </div>
      <div class="footer__actions">
        <BaseButton
          v-if="isPrevButtonVisible"
          class="footer__action footer__action_prev"
          is-dim
          @click="goPrev"
        >
          <BaseIcon name="arrow_left" class="button__icon" />
          <span v-if="prevButtonText" v-text="prevButtonText" />
        </BaseButton>
        <BaseButton
          v-if="isNextButtonVisible"
          class="footer__action footer__action_next"
          is-bright
          @click="goNext"
        >
          <span v-if="nextButtonText" v-text="nextButtonText" />
          <BaseIcon name="arrow_right" class="button__icon button__icon_after" />
        </BaseButton>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import { ACTION_NAMES } from '@/App.vue';

import BaseIcon from '@/components/BaseIcon.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseProgress from '@/components/BaseProgress.vue';

export default {
  name: 'TheFooter',
  components: {
    BaseIcon,
    BaseButton,
    BaseProgress,
  },
  computed: {
    ...mapState(['progress', 'progressCount']),
    isPrevButtonVisible() {
      return Boolean(this.$route.meta && this.$route.meta.prev);
    },
    isNextButtonVisible() {
      return Boolean(this.$route.meta && this.$route.meta.next);
    },
    prevButtonText() {
      const { prevButtonText = 'Назад' } = this.$route.meta || {};
      return prevButtonText;
    },
    nextButtonText() {
      const { nextButtonText = 'Далее' } = this.$route.meta || {};
      return nextButtonText;
    },
  },
  methods: {
    goPrev() {
      this.$root.$emit(ACTION_NAMES.PREV);
    },
    goNext() {
      this.$root.$emit(ACTION_NAMES.NEXT);
    },
  },
};
</script>

<style lang="stylus">
.footer
  display block
  +portrait()
    padding 1.25em 0
    background-color #fff
    background linear-gradient(180deg, alpha(@background-color, 0%), @background-color 50%)
  +landscape()
    background-color #fff
    box-shadow 0 0 2em rgba(0, 0, 0, 0.07)
    padding 1.12em 0

  &__inner
    padding-left 1.4em
    padding-right @padding-left
    +landscape()
      display flex
      align-items center
      padding-left 2em
      padding-right @padding-left

  &__progress
    display none
    +landscape()
      display block
      flex-grow 1
      flex-basis 0
      max-width calc(100% - 18em)
      padding-right 4em

  &__actions
    display flex
    +landscape()
      width 18em

  &__action
    &_next
      &.button
        margin-left auto
    &_prev
      &.button
        margin-right auto
    &.button
      flex 0 0 50%
      max-width 48%
      padding 0
</style>
